import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { grey } from '@helpers/grey';
import { Device, from } from '@helpers/media';
import scrollbars from '@helpers/scrollbars';
import styled from 'styled-components';
const Container = styled.nav `
  ${scrollbars}

  position: fixed;
  z-index: 100;
  top: var(--headerHeight);
  left: 0;
  display: flex;
  flex-direction: column;
  height: calc(100% - var(--headerHeight));
  width: 100%;
  padding: 0px var(--sitePadding) 10px;
  overflow-y: auto;
  background-color: ${brand.global.white};
  opacity: 1;
  transform: translateX(0);
  pointer-events: auto;
  ${transition('opacity transform', '0.3s')}

  &[aria-hidden='true'] {
    opacity: 0;
    transform: translateX(-100%);
    pointer-events: none;
  }

  @media ${from(Device.DesktopSmall)} {
    display: none;
  }
`;
const SectionTitle = styled.strong `
  display: block;
  ${fonts.ubuntu.medium}
  font-size: 12px;
  margin-top: 20px;
`;
const ItemList = styled.ul `
  display: flex;
  flex-direction: column;

  &:last-of-type {
    margin-bottom: 20px;
  }
`;
const Item = styled.li `
  border-bottom: 1px solid ${grey(90)};

  &[data-back='true'] {
    position: sticky;
    z-index: 1;
    top: 0;
    padding: 0;
    margin: 0 calc(var(--sitePadding) * -1);
    background: ${brand.global.white};
    border-color: transparent;
  }

  &[data-no-border='true'] {
    border: none;
  }

  [data-navigation='main'] & {
    font-size: 20px;
    color: ${brand.primary.purple.base};

    &:has([data-bold='true']) {
      ${fonts.ubuntu.medium}
    }
  }

  [data-navigation='secondary'] & {
    color: ${brand.primary.base};
  }

  svg {
    --iconSize: 20px;

    width: var(--iconSize);
    height: var(--iconSize);
    color: currentColor;
  }
`;
const CategoryTitle = styled.strong `
  display: block;
  ${fonts.ubuntu.bold}
  font-size: 18px;
  margin-bottom: 6px;
`;
const Link = styled.a `
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-size: 16px;
  color: currentColor;
  margin: 0;
  padding: 14px 0;
  text-decoration: none;
  cursor: pointer;
`;
const ArrowButton = styled.button.attrs({ type: 'button' }) `
  ${ButtonReset}
  position: relative;
  width: 44px;
  height: 44px;
  margin: -10px 0;
  color: currentColor;

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 20%;
    left: -4px;
    width: 1px;
    height: 60%;
    background-color: currentColor;
    opacity: 0.25;
  }
`;
const Back = styled.span `
  position: relative;
  display: flex;
  align-items: center;
  column-gap: 10px;
  width: 100%;
  height: 46px;
  padding: 0px var(--sitePadding);
  margin: 0 0 8px;
  color: ${brand.primary.base};
  cursor: pointer;

  svg {
    --iconSize: 14px;
  }

  span {
    ${fonts.openSans.light}
    font-size: 12px;
    line-height: 1em;
    color: currentColor;
  }
`;
const ParentLink = styled.a `
  display: block;
  width: 100%;
  ${fonts.ubuntu.medium}
  font-size: 12px;
  line-height: 1.1em;
  padding: 0 var(--sitePadding) 20px;
  color: ${brand.primary.purple.base};
`;
const LinkButton = styled.button `
  ${ButtonReset};
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-size: 16px;
  color: currentColor;
  margin: 0;
  padding: 14px 0;
  text-decoration: none;
  cursor: pointer;
`;
const MobileNavigationStyles = {
    ArrowButton,
    Back,
    CategoryTitle,
    Container,
    Item,
    ItemList,
    Link,
    ParentLink,
    SectionTitle,
    LinkButton,
};
export default MobileNavigationStyles;
